export const CONCESSIONAIRE_DETAIL_BY_ID = 'CONCESSIONAIRE_DETAIL_BY_ID'
export const LOADING_SEARCH = 'LOADING_SEARCH'
export const SELECTED_CARS_QUOTE = 'SELECTED_CARS_QUOTE'
export const LIST_CARS_BY_CONCESSIONAIRE = 'LIST_CARS_BY_CONCESSIONAIRE'
export const UPDATE_FILTER_BY_MODEL = 'UPDATE_FILTER_BY_MODEL'